import { render, staticRenderFns } from "./SOPStandard.vue?vue&type=template&id=d6d7e5c0&scoped=true&"
import script from "./SOPStandard.vue?vue&type=script&lang=js&"
export * from "./SOPStandard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6d7e5c0",
  null
  
)

export default component.exports